import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import AuthServiceFactory from "@/services/authentication/AuthServiceFactory";
import MaterialCard from "@/components/material/Card.vue";
import CustomerInformation from "@/components/customer/CustomerInformation.vue";
let CustomersView = class CustomersView extends Vue {
    constructor() {
        super();
        this.authService = AuthServiceFactory.GetAuthService();
        this.customers = new Array();
        this.searchCustomerTerm = "";
        this.showCustomerInformation = false;
        this.selectedRows = [];
        this.headers = [
            {
                text: "Name",
                align: "start",
                sortable: false,
                value: "fullName"
            },
            {
                text: "Email",
                align: "start",
                sortable: false,
                value: "email"
            },
            {
                text: "Organization",
                align: "start",
                sortable: false,
                value: "organizationName"
            }
        ];
        this.simplifiedHeaders = [
            {
                text: "Name",
                align: "start",
                sortable: false,
                value: "fullName"
            },
            {
                text: "Email",
                align: "start",
                sortable: false,
                value: "email"
            }
        ];
        this.selectedCustomer = null;
        this.isNewCustomer = true;
    }
    get itemsPerPage() {
        return 100;
    }
    customerClicked(customer) {
        this.isNewCustomer = false;
        this.selectedCustomer = customer;
        this.showCustomerInformation = true;
    }
    async mounted() {
        this.user = await this.authService.getUser();
        await this.getCustomers();
    }
    searchCustomerTermChanged(event) {
        console.log("Search term changed: " + JSON.stringify(this.searchCustomerTerm));
    }
    searchClicked() {
        console.log("Search clicked: " + this.searchCustomerTerm);
        this.searchCustomerTerm = "";
    }
    async getCustomers() {
        let customer = {};
        customer.firstName = "David";
        customer.lastName = "Light";
        customer.phone = "937-360-3275";
        customer.fax = "";
        customer.email = "david.light@vanasolutions.com";
        customer.customerId = 1;
        customer.sourceReferenceId = "DLIGHT20";
        customer.accountingCustomerId = "DLIGHT20";
        customer.fullName = "David Light";
        customer.organizationName = "Vana Solutions";
        customer.address1 = "3610 Pentagon Blvd";
        customer.address2 = "Suite 110";
        customer.city = "Beavercreek";
        customer.state = "OH";
        customer.zipCode = "45431";
        customer.country = "US";
        this.customers.push(customer);
    }
    customerInformationChanged(customer) {
        console.log("Customer information changed: " + JSON.stringify(customer));
        this.selectedCustomer = {};
        this.showCustomerInformation = false;
        if (this.isNewCustomer === true) {
            this.customers.push(customer);
        }
    }
    customerInformationCanceled(customer) {
        console.log("Customer information canceled: " + JSON.stringify(customer));
        this.selectedCustomer = {};
        this.showCustomerInformation = false;
    }
    newCustomerClicked() {
        console.log("New customer clicked");
        this.selectedCustomer = {};
        this.showCustomerInformation = true;
        this.isNewCustomer = true;
    }
};
CustomersView = tslib_1.__decorate([
    Component({
        name: "Customers",
        components: {
            MaterialCard,
            CustomerInformation
        }
    })
], CustomersView);
export default CustomersView;
